import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import ur from "./locales/ur.json";
import bn from "./locales/bn.json";
import sd from "./locales/sd.json";
import es from "./locales/es.json";

const LANGUAGE_STORAGE_KEY = "muradi_language";

const initialLanguage = localStorage.getItem(LANGUAGE_STORAGE_KEY) || "en";

const applyDirection = (lng: string) => {
  document.documentElement.dir = "ltr";
  document.documentElement.lang = lng;
};

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ur: { translation: ur },
    bn: { translation: bn },
    sd: { translation: sd },
    es: { translation: es },
  },
  lng: initialLanguage,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

applyDirection(initialLanguage);
i18n.on("languageChanged", applyDirection);

export default i18n;
